import { z } from 'zod';
import { zLookup } from '@/utils/zodHelper';

export const NncSchema = z.object({
  id: z.number(),
  reference_number: z.string(),
  country: z.string(),
  unit: zLookup(),
  nnc_date: z.string(),
  product: z.string(),
  production_order: z.string(),
  operation: z.string(),
  operator_name: z.string(),
  machine: z.string(),
  failure_category_description: z.string(),
  description: z.string(),
  status: zLookup().optional(),
  division: zLookup(),
  production_phase: zLookup(),
  machine_enrichment: zLookup(),
  operator_code: z.string(),
  operator_name_enrichment: z.string(),
  comment: z.string(),
  modified_by: z.number().optional(),
});

export const NncSearchSchema = z.object({
  start_date: z.date().optional().nullable(),
  end_date: z.date().optional().nullable(),
  country: zLookup().optional(),
  unit: zLookup().optional(),
  status: z.array(zLookup()).optional(),
});

export const AnalysisFormSchema = z.object({
  comment_general: z.string().min(1, 'Campo obrigatório'),
  modos: z.array(
    z.object({
      origin: zLookup().optional(),
      cause: zLookup().optional(),
      comment: z.string().optional(),
    }),
  ),
});

export type AnalysisFormType = z.infer<typeof AnalysisFormSchema>;
export type NncSchemaType = z.infer<typeof NncSchema>;
export type NncSearchSchemaType = z.infer<typeof NncSearchSchema>;
